module.exports = __webpack_public_path__ + "media/en_au_s4_Madeline.bb04607c.mp3";